'use strict';

function handlePostUpdate(messageType, message) {

    if ($('.update-messages').length === 0) {
        $('body').append(
            '<div class="update-messages"></div>'
        );
    }

    $('.update-messages').append(
        '<div class="alert ' + messageType + ' data-updated text-center" role="alert">' +
        message +
        '</div>'
    );

    setTimeout(function () {
        $('.data-updated').remove();
    }, 5000);
}

/**
 * Posts the order-lookup form and swaps the component's content for the result
 * (return-request form or expired-window message).
 * @param {jQuery} $form - the lookup form
 * @param {Function} [onFailure] - runs when the lookup is rejected or the request fails
 */
function submitLookup($form, onFailure) {
    $.ajax({
        url: $form.attr('action'),
        type: 'post',
        data: $form.serialize(),
        success: function (data) {
            if (data.success) {
                $('.experience-dynamic-returnTrackOrder').removeClass('d-none').html(data.html);
                return;
            }
            $('.error-control').removeClass('d-none');
            $('.error-feedback').html('<strong>' + data.errorMessage + '</strong>');
            if (onFailure) {
                onFailure();
            }
        },
        error: function () {
            if (onFailure) {
                onFailure();
            }
        },
        complete: function () {
            $.spinner().stop();
        }
    });
}

$(document).ready(function () {
    const urlParams = new URLSearchParams(window.location.search);
    const orderEmail = urlParams.get('orderEmail');
    const orderNo = urlParams.get('orderNo');
    // Only auto-submit when the lookup form is actually on the page. When deep-linked, the
    // server (returnTrackOrder.js) already renders the Return Request Form directly, so
    // form.trackorder is absent and there is nothing to submit - leave that form visible.
    if (orderNo && orderEmail && $('form.trackorder').length) {
        // fallback path (the server could not deep-render) - hide the order-lookup form up
        // front so the shopper lands straight on the Return Request Form (no search step).
        // It is revealed again only if the automatic lookup fails, so they can retry.
        var $lookup = $('.experience-dynamic-returnTrackOrder');
        $lookup.addClass('d-none');
        $.spinner().start();
        $('#trackOrder-form-email').val(orderEmail);
        $('#trackOrder-form-orderNumber').val(orderNo);
        history.replaceState('Returns', document.title, window.location.href.split('?')[0]);
        submitLookup($('form.trackorder'), function () {
            $lookup.removeClass('d-none'); // lookup failed - let the shopper see/retry it
        });
    }

    var returnsConfirmation = sessionStorage.getItem('returnsConfirmationMessage');
    if (returnsConfirmation) {
        sessionStorage.removeItem('returnsConfirmationMessage');
        $.spinner().start();
        // pass the submitted order/items back so the server renders the structured
        // confirmation (it falls back to the content asset without them)
        var successUrl = $('.returns-success-js').val();
        if (!successUrl) {
            $.spinner().stop();
            return;
        }
        try {
            var confirmationData = JSON.parse(returnsConfirmation);
            if (confirmationData && confirmationData.orderNo) {
                successUrl += (successUrl.indexOf('?') > -1 ? '&' : '?')
                    + 'orderNo=' + encodeURIComponent(confirmationData.orderNo)
                    + '&orderEmail=' + encodeURIComponent(confirmationData.orderEmail)
                    + '&items=' + encodeURIComponent(confirmationData.items);
            }
        } catch (parseError) { /* non-JSON flag - content asset fallback */ }
        $.get(successUrl, function (data) {
            var $component = $('.experience-dynamic-returnTrackOrder');
            // the confirmation carries its own title, so the page heading above the component is hidden
            $component.prev('.experience-commerce_assets-heading').addClass('d-none');
            $component.html(data.returnsSuccess);
        }).always(function () {
            $.spinner().stop();
        });
    }

    $('body').on('change', '.submit-return-form .reason', function () {
        if ($(this).val()) {
            $(this).removeClass('is-invalid');
        }
    });

    $('body').on('click', '.submit-return-form .check-item, .submit-return-form .stepper__button', function () {
        var checkBoxes = $(this).closest('form').find('.check-item');
        var qty = 0;

        for (let i = 0; i < checkBoxes.length; i++) {
            // iterate the elements themselves: ids use the template loop index, which skips
            // return-blocked rows, so positional '#check-item-' + i desyncs on mixed orders
            let row = $(checkBoxes[i]).closest('.return-product__detail');
            let reason = row.find('.reason');
            if (checkBoxes[i].checked) {
                $(reason).attr('required', '');
                if (!$('.error-control').hasClass('d-none')) {
                    $('.error-control').addClass('d-none');
                }
                qty += Number(row.find('.stepper__input').val());
            } else if ($(reason).attr('required')) {
                $(reason).removeAttr('required');
            }
        }
        $('.items-selected').text(qty);
    });

    $('body').on('submit', 'form.trackorder', function (e) {
        e.preventDefault();
        $.spinner().start();
        submitLookup($(this));
    });

    $('body').on('submit', 'form.submit-return-form', function (e) {
        try {
            var description = {};
            var descriptionList = [];
            var checkBoxes = $(this).find('.check-item');
            var checked = [];
            var error = null;

            for (let i = 0; i < checkBoxes.length; i++) {
                if (checkBoxes[i].checked) {
                    checked.push(checkBoxes[i]);

                    if (!$(checkBoxes[i]).closest('.return-product__detail').find('.reason').val()) {
                        error = true;
                        break;
                    }
                }
            }

            var captchaMissing = !!(window.grecaptcha && window.grecaptcha.getResponse() === '');
            if (!checked.length) {
                handlePostUpdate('alert-error', 'Must select one or more items to proceed!');
            } else if (error) {
                handlePostUpdate('alert-error', 'Must select one of the reason options!');
            } else if (captchaMissing) {
                handlePostUpdate('alert-error', 'You must pass the reCAPTCHA!');
            }
            if (!checked.length || error || captchaMissing) {
                // the confirmation screen must only render after a real web-to-case post
                e.preventDefault();
                return;
            }

            for (let j = 0; j < checked.length; j++) {
                description = {};
                var lineItem = $('#' + $(checked[j]).attr('id')).closest('.return-product__detail');
                description.UPC = lineItem.find('.line-item-sku').data('upc');
                description.SKU = lineItem.find('.line-item-sku').data('sku');
                description.Qty = Number(lineItem.find('.stepper__input').val());
                var attributes = $(lineItem).find('.line-item-attribute');
                for (let k = 0; k < attributes.length; k++) {
                    let currentAttr = $(attributes[k]);
                    description[$(currentAttr).data('value')] = currentAttr.find('#attr-value-' + k).text();
                }
                var option = lineItem.find('option');
                description.reason = option[lineItem.find('.reason').val()].innerText;
                descriptionList.push(description);
            }
            let comments = document.querySelector('.submit-return-form .custom-text-area').value;
            if (comments) {
                comments = `Comments: ${comments}`;
                descriptionList.push(comments);
            }
            $('#description').val(JSON.stringify(descriptionList));
            sessionStorage.setItem('returnsConfirmationMessage', JSON.stringify({
                // the order number comes from the form's own data attribute, not from the
                // Salesforce field id, which is specific to the org the form posts to
                orderNo: $('form.submit-return-form').data('orderNo'),
                orderEmail: $('#email').val(),
                items: checked.map(function (box) {
                    var row = $(box).closest('.return-product__detail');
                    return row.data('id') + ':' + (Number(row.find('.stepper__input').val()) || 1);
                }).join(',')
            }));
        } catch (err) {
            handlePostUpdate('alert-error', 'An error occurred while processing your return. Please submit the return again.');
            e.preventDefault();
        }
    });
});
